/* eslint-disable react/destructuring-assignment -- falso positivo: este .ts no tiene ningun
   componente, flowVersions es un parametro posicional (no un objeto props), no hay nada que
   destructurar. */
import { FlowVersion } from '../../../../services/types/Flow';

const GetFlowCurrentVersion = (flowVersions: FlowVersion[] | null) =>
  flowVersions
    ? flowVersions.sort((a, b) => {
        if (a.lap === b.lap) {
          return b.version - a.version;
        }
        return b.lap - a.lap;
      })[0]
    : null;

export default GetFlowCurrentVersion;
